const en={
    common:{
        yes:"Yes",
        no:"No",
        verfRequirement:"Verification Requirement",
        baseInfo:"Basic information of verified factory",
        clientNameLocal:"Registered Company Name (local language)",
        clientNameLocalError:"Please enter the company name",
        clientNameEn:"Registered Company Name (English)",
        addressLocal:"Company Address (local language)",
        addressLocalError:"Please enter the address",
        addressEn:"Company Address (English)",
        industry:"Industry",
        businessType:"Company type",
        pleaseDetail:"Please enter",
        contactInfo:"Contact Information",
        contact:"Contact Person",
        contactError:"Please enter the contact name",
        mobile:"Telephone",
        mobileError:"Please enter the contact number",
        email:"E-mail Address",
        emailError:"Please enter the E-mail Address",
        countryError:"Please select country",
        taxCodeError:"Please enter the tax code",
        title:"Position",
        titleError:"Please enter the position of contact person",
        submit:"Submit",
        hotline:"Hotline",
        moreService:"More service",
        successMsg:"Well received the application with many thanks. We will check it and contact with you as soon as possible. Service Contact Number: +86 755 21608956",
        view:"View",
        selectFile:"Select File",        
        verificationDate:"Verification Date",
        pleaseSelectFile:"Please select File",
        download:"Download",
        delete:"Delete",
        uploadFile:"Upload file",
        taxCode:"Tax Code",
        country:"Country",
        province:"Province",
        station:"Nearby Transportation (high speed rail station, airport, etc)",
        requiredError:"This is a required field, please enter",
        numericError:"Please enter a number",        
        legalPersonName:"Name of Legal Representative",
        legalPersonTitle:"Title of Legal Representative"           
    },
    actions:{
        new:"New",
        view:"View",
        edit:"Edit",
        status:"Status",
        followup:"Follow-up",
        delete:"Delete",
        actions:"Actions",
        refresh:"Refresh",
        back:"Return",
        share:"Share",
        submit:"Submit",
        search:"Search",
        download:"Download",
        close:"Close",
        copy:"Copy",
        cancel:"Cancel",
        ok:"Ok",
        add:"Add",
        createAppForm:"Create Application Form",
        downAppForm:"Download Application Form",
        send:"Send",
        createQuotation:"Create Quotation",
        createContract:"Create Contract",
        archivingContract:"Archiving Contract",
        archivingApplicationForm:"Archiving Application Form",
        invoice:"Invoice",
        downContract:"Download Contract",
        bindingClient:"Binding Client",
        newClient:"New Client",
        binding:"Binding",
        assignSales:"Assign Sales",
        assignCS:"Assign CS",
        createInvoice:"Create Invoice",
        archivingInvoice:"Archiving Invoice",
        downInvoice:"Download Invoice",    
        internalSharing:"Internal Share",
        feedback:"Feedback",
        confirm:"Confirm",
        argue:"Argue",
        upload:"Upload",
        save:"Save",
        cancelReason:"Cancel Reason"
    },
    generalService:{
        title:"General Service Application Form",
        serviceInfo:"Service Information",
        serviceType:"Service Type",
        serviceDate:"Expected Service Date",
        serviceDateError:"Please enter the Expected service Date",  
    },        
    fem:{
        formName:"Higg FEM Verification Application Form",
        type:"Verification Type",
        typeFoundation:"Higg Foundation - No Scoring, Verify the data and records in last 12 months",
        typeFEM:"Higg FEM - With scoring, verify the data and records in last calendar year",
        self:"Verification Level",
        envManagementSystem:"Environmental Management System",
        energyGreenhouseGases:"Energy Use and GHG Emission",
        waterResources:"Water Use",
        wastewater:"Wastewater",
        exhaustEmissions:"Emissions to Air",
        waste:"Waste Management",
        chemicalManagement:"Chemical Management",
        experience:"Verification Experience",
        experience1:"First",
        experience2:"Secondary",
        experience3:"Third Time and above",
        model:"Verification Mode",
        model1:"Onsite Verification",
        model2:"Offsite Verification(*Please check with your client, advance agreement is required)",
        selfassessment:"Is the self-assessment posted",
        promoteBrand:"Brands",
        auditDate:"Expected Verification Date",
        auditDateError:"Please enter the Expected verification Date",
        productType:"Product type and annual shipment volume",
        technology:"Main product process (Please provide production process flow instead if applicable)",
        chemical:"Does the factory use chemical in production processes? Please specify if applicable",
        wwt:"Does the factory have wastewater treatment plant?",
        coverarea:"Factory size (floor area)",
        coverareaError:"Please enter the factory size",
        employee:"NO. of employees",
        employeeError:"Please enter the number",
        esc:"Environmental management system certificates, please specify"
    },
    slcp:{
        formName:"SLCP Verification Application Form",
        type:"Verification Step",
        experience:"Verification Experience",
        experience1:"First Time",
        experience2:"Annual Time",
        experience3:"Follow-up",
        selfassessment:"Does the facility submit the self-assessment? ",
        postDate:"Submit Date",
        ahSystem:"AH platform selection",
        other:"Other",
        promoteBrand:"Brand",
        announcementType:"Verification Announcement",
        announcementType1:"Announced",
        announcementType2:"Unannounced",
        announcementType3:"Semi-Announced with 10-day window",
        auditDate:"Expected Verification Date",
        auditDateError:"Please enter the Expected verification Date",
        model:"Verification Type",
        model1:"Onsite Verification",
        model2:"Full Virtual Verification",
        model3:"Virtual Verification+ Onsite Verification",
        apsca:"Is APSCA verifier requested?",
        employee:"Workers",
        employeeError:"Please enter the number of workers",
        manager:"Supervisors",
        managerError:"Please enter the number of supervisors",
        csr:"CSR management system certificates (e.g.: BSCI, WRAP, ISO and etc.)",
        serviceProvider:"Onsite Service Providers (e.g. security, janitor, cleaner)",
        productionBuildings:"Numbers of building-production",
        dormitories:"Numbers of buildings-Dormitory",
        warehouses:"Numbers of buildings-Warehouse",
        otherBuildings:"Numbers of buildings-Other",
        productType:"Main product type",
        technology:"Main production processes",
        times:"Times",
        tipWorker:"Kind reminder: Please ensure that the reported number of people is accurate based on the definition of workers",
        tipManager:"Kind reminder: Please ensure that the number of supervisors reported is accurate", 
        workerInclude:"Workers/production workers referring to:",
        workerDetail:"1. Personnel directly involved in product production, i.e. operators on the production line, such as sewing workers, cutting workers, packing workers, etc. 2. workers who do not directly produce products but participate in the production process, such as QA, mechanics, electricians, porters, material distribution workers, etc.",
        workerExclude:"Workers/production workers do not include:",
        workerExDetail:"any supervisory positions, i.e. anyone with 'management' responsibilities, such as sewing group supervisors, mechanic team leaders, etc."     
    },
    application_confirm:{
        applicationForm:"Application form",
        applicationFormUpload:"Application Confirmation",
        notExist:"Application form does not exist",
        error:"Application form exceptions",
        success:"Application has been submitted, we will provide quotations as soon as possible, service hotline: +86 755 21608956",
        submitError:"Application submission exception, please contact us: +86 755 21608956",
        pleaseSelectfile:"Please select the signed and stamped application form"
    },
    confirm_letter:{
        confirmLetter:"Confirmation Letter Return Receipt",
        notExist:"Service order does not exist",
        error:"Service order exceptions",
        success:"Scheduling has been confirmed, Service hotline: +86 755 21608956",
        submitError:"To submit an exception, please contact us: +86 755 21608956",
    },
    verfDocument:{
        verfDocument:"Verification Documents",
        pre:"Pre-review Documents",
        other:"Other Documents",
        file:"File",
        updateTime:"Update time",
        size:"Size",
        status:"Status",
        comments:"Comments",
        preTitle:"Pre-review document list",
        pre1:"<li>The total number of employees in 2025 (the average of the total number of salaried employees in the 12 months of 2025, full-time and part-time staff need to be counted separately) </li><li> </li><li>Shipment Volume Statistics Table for 2025 (Monthly statistics, Shipment volume = Total Shipment Volume - Rejected Volume)</li><li>Operating days Statistics Table for 2025 (Refer to attendance records, calculated monthly. If the number of people or the time on a given day is less than half, it is counted as 0.5 days)</li><li>The aggregated data/meter/invoices or receipt/ estimate record of energy source (Electricity, Diesel, Gasoline, LPG, etc) in 2025</li><li>EAC (green electricity, etc) or Carbon offset certificate purchased</li><li>The aggregated data/meter/invoices/receipt/estimate record of water source (municipal water, rain water, ground water, etc) in 2025  </li><li>The aggregated data/meter/invoices/receipt/estimate record of wastewater discharged (domestic, industrial, domestic&industrial combined etc) in 2025  </li><li>The aggregated data/ meter/invoices/receipt/estimate record of wastewater sludge (domestic sludge (septic tank sludge) and industrial sludge) in 2025</li><li>Refrigerant (R22, R32, R410A, etc) inventory and tracking and addition records </li><li>The aggregated data/ meter/invoices/receipt/estimate record of waste source (waste cartoons, waste plastics, household garbage, kitchen waste, empty chemical containers, etc) generation/transfer in 2025</li>",
    },
    traningSurvey:{
        title:"Training Questionaire",
        question1:"Question 1: Topic of Seminar",
        question2:"Question 2: The date you join the seminar",
        question3:"Question 1: Could the content of the seminar answer your questions about the project in your company?",
        question4:"Question 2: Could the content of the seminar provide the guideline to implement your job in company?",
        question5:"Question 3: Was this seminar suitable and inspired to you about the awareness and implementation the environmental management?",
        question6:"Question 4: Did the training material have the tighten structure and easily to use?",
        question7:"Question 5: Did the trainer present in logically, clearly and concenstration?",
        question8:"Question 6: Did the presenter combine many cases and practice cases?",
        question9:"Question 7: Did the presenter grasp the process of the seminar?",
        question10:"Question 8: Please provide your evaluation about the attitude, responsibilities and service style of the staff.",
        question11:"Question 9: Please evaluate the convenience and usefulness of the training material.",
        question12:"Question 10: If you have any suggestions, or additional information, kindly send to us",
        nonExist:"Traning course is invalid",
        error:"Data is abnormal",
        success:"Thank you very much for your feedback!",
        submiterror:"For any information, kindly contact admin: +86 755 21608956",
        nameerror:"Topic could not be empty",
        dateerror:"The date could not be empty"
    },
    aws:{
        formName:"Alliance for Water Stewardship Certification",
        applicantInformation:"Applicant Information",
        facility:"Facility",
        desiredCertificationLevel:"Desired Certification Level",
        certificationType:"Certification Type",
        auditType: "Audit Type",
        factoryName:"Factory Name",
        referenceNumber:"AWS Reference Number (if any)",
        address:"Address",
        employees:"No. of employees",
        occupiedArea:"Occupied area (Unit: Square Meters) ",
        mainProducts:"Main Products /Services to be certified",
        mainManufacture:"Please describe the main manufacture/service flow processes",
        wastewater:"Would Industrial wastewater be generated during daily operation? ",
        annualWater:"Annual water consumption Amount (Unit: ton)",
        sourceWater:"What is the source for Water input(select the applicable one(s))",
        wastewaterReused:"Would any wastewater be reused or recycled onsite? <br/>If yes, please describe the reused or recycled situation:<br/>-	How many tons of wastewater monthly?<br/>-	What is the reused/recycled process?<br/>-	Where the reused/rec",
        wastewaterTreatmentPlant:"Does the facility has its own wastewater treatment plant/facility/process onsite?",
        dischargedWastewater:"Where the discharged wastewater would be channeled to? (outside the boundary of facility)",
        reason:"Reason",
        certLevError:"Please select desired certification level",
        certTypeError:"Please select certification type",
        auditTypeError:"Please select audit type",
        factoryNameError:"Please enter factory name",
        addressError:"Please enter factory address",
        employeesError:"Please enter No. of employees",
        occupiedAreaError:"Please enter occupied area",
        mainProductsError:"Please describe main products /services provided by the facility",
        mainManufactureError:"Please describe the main production processes",
        wastewaterError:"Please confirm whether the facility generates industry wastewater or not?"        
    },
    zero:{
        formName:"SUPPLIER TO ZERO LEVEL 2 REVIEW APPLICATION FORM",
        experience:"Supplier to Zero level 2 review experience",
        finishLevel1:"Is the Supplier to Zero level 1 completed",
        model:"Review mode",
        zdhcID:"ZDHC Gateway ID",
        openingHour:"Opening hour",
        fromFactoryAirport:"How far from factory is the airport/station (by car)",
        cmc:"Chemical management certificate",
        numberofChemical:"The number of chemical inventory at the facility",
        mrsl:"MRSL Conformity Certificate",
        chemicalUsed:"The quantity of chemical used",
        materials:"Materials",
        serviceDate:"Expected Review Date",
    },    
    zdhc:{
        formName:"ZDHC VERIFIED INCHECK LEVEL 1 APPLICATION FORM",
        experience:"ZDHC Verified Incheck Level 1 experience",
        performance:"Performance Incheck Report of past three months or three consecutive quarters are completed",
        model:"Type process",
        productionArea:"Production area",
        administration:"Administration",	
        chemicalStorageArea:"Chemical storage area",
        other:"Other"	
    },
    ghg:{
        formName:"GHG Inventory Application Form",
        year:"Year",
        energySource:"Energy  Source",
        multipleSite:"Multiple site",
        involvesNewEnergy:"Involves new energy",
        onsitePowerGeneration:"Onsite Power Generation",
        energySupplytoOtherSites:"Energy Supply to other sites",
        carbonOffset:"Carbon offset",
        mainProduction:"The main production equipments",
        onsiteCanteen:"Onsite canteen or dormitory",
        subcontractedProcess:"Subcontracted process?",
        millsLease:"Mills lease",
        operationFacility:"Operation facility (switch room,waste water treatment plant, air emission scrubber, air conditioners, Compressor)",
        sitEnergyMeteringMap:"Site energy metering map",
        chemicalInventory:"Chemical inventory (Specialty gases Included)",
        fireExtinguisher:"Fire extinguisher(Co2) used",
        fireSuppressionSystem:"HFC-227ea fire suppression system",
        wawHandlingProcess:"Waste water,Air emissions,waste handling process"
    },
    survey:{
        q1:"Please rate the timeliness of service delivery (phone, e-mail and proposal submission)", 
        q2:"Please rate the clarification of doubts / claims satisfaction",   
        q3:"Please rate our technical support overall", 
        q4:"Please rate our commercial support overall",    
        q5:"Please rate the quality of our service efficiency", 
        q6:"Please rate the quality of our service communication",
        q7:"Please rate the quality of our service accuracy",
        q8:"Please rate our auditors punctuality, treatment and personal presentation ",
        q9:"How do you qualify the auditor's expertise in the industry audited? ",
        q10:"Do you consider that our evaluations were accurate, clear and organized during the auditing process? ",
        q11:"Did you receive detailed information about the audit process and results during the Opening & Closing Meetings? ",
        q12:"Were your questions answered satisfactorily? ",
        q13:"Please rate the timely delivery of the audit report",
        q14:"How likely is it that you would use our services again?",
        q15:"How do you rate the level of knowledge and skills of our auditor?",
        q16:"Would you recommend GreenPont services to a colleague or acquaintance?",
        q17:"Overall, how satisfied are you with GreenPont?",        
        suggestion:"Suggestions",
        formName:"Service Satisfaction Survey",
        companyName:"Company Name",
        feedback:"Thank you for your feedback",
        feedbackError:"Feedback submission error, please contact the administrator"
    }, 
    fpa:{
        formName:"Online Information Collection Form",
        experience:"Follow up audit cycle",
        auditDate:"Audit Window",
        attachment:"Supplier Audit Report (Report on Issues to be Followed up)",
        brandContactInfo:"Client Contact",
        auditRequirement:"Audit Request",
        announcementType3:"Semi-Announced",
        specialNotes:"Special Notes",
        auditDateError:"Please enter the audit window",
        contactSC:"Schedule notification Recipient",
        contactRP:"Report Recipient",
        contactAT:"ZT Alert Recipient"        
    },
}
export default en